import {
  DebugForm,
  DisplayFormErrors,
  InputField,
  SwitchField,
  VerticalForm,
} from "melco-shared-logic";
import { FullWidthSpace } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { MachineStatusMachineGroupsList } from "./MachineStatusMachineGroupsList";
import { MachineStatusAddMachineGroupDrawer } from "./MachineStatusAddMachineGroupDrawer";
import { runes } from "runes2";

export const DisplayMachineStatusViewDetailForm: React.FC = () => {
  const { t } = useTranslation();
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  return (
    <VerticalForm>
      <DisplayFormErrors />

      <FullWidthSpace direction="vertical" size="middle">
        <>
          <InputField
            maxLength={12}
            showCount
            name="name"
            data-cy-id="machinestatus-view-name-input"
            label={t("reporting.machinestatus.view.form.name")}
          />

          <MachineStatusMachineGroupsList setDrawerOpen={setDrawerOpen} />

          <SwitchField
            data-cy-id="machinestatus-view-grouped-display"
            name="grouped_display"
            label={t("reporting.machinestatus.view.form.grouped_display")}
          />

          <MachineStatusAddMachineGroupDrawer
            isDrawerOpen={isDrawerOpen}
            setDrawerOpen={setDrawerOpen}
          />
        </>
      </FullWidthSpace>

      {false && <DebugForm />}
    </VerticalForm>
  );
};
